import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../../util/app";

function ListPatientAssessment({ items = [], onView }) {
    if (!items.length)
        return (
            <div className="text-center text-pink">
                <h3>No Assessment has been recorded yet!</h3>
            </div>
        );
    return (
        <div className="inbox-body">
            <div className="inbox-body">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }}>SN</th>
                            <th style={{ width: "20%" }}>Date & Time</th>
                            <th style={{ width: "50%" }}>Result</th>
                            <th style={{ width: "20%" }}>Staff</th>
                            <th style={{ width: "15%" }}>Confirmation</th>
                            <th style={{ width: "10%" }}>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                                <td className="inbox-small-cells">
                                    <div className="todo-check pull-left">{index + 1}</div>
                                </td>

                                <td className="view-message">
                                    <b>{cleanDate(item.created_at)}</b>
                                    <p className="text-muted">
                                        <TimeAgo date={item.created_at} />
                                    </p>
                                </td>

                                <td className="view-message">
                                    <p>
                                        {item.score.desc} <br />
                                        <span className="badge badge-success">Score: {item.score.value}</span>
                                    </p>
                                </td>
                                <td className="view-message">
                                    <StaffProfileCard item={item.author} />
                                </td>
                                <td className="view-message">
                                    {item.confirm ? <span className="badge badge-success">Confirmed</span> : <span className="badge badge-danger">Unconfirmed</span>}
                                    {item.confirm && (
                                        <p className="text-muted">
                                            <TimeAgo date={item.confirm.datetime} />
                                        </p>
                                    )}
                                </td>
                                <td className="view-message text-right">
                                    <button type="button" onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ListPatientAssessment;
